import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import WeekText from "../../Main/Prevention/Week/WeekText.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data from "../../Data/patents/patents.json";

export default function Patents() {
  useSEO(seoConfig.patents);

  return (
    <section className="structure">
      <Breadcrumbs />

      <h1 className="weekpage__title">
        Патенты и разрешительная документация ГБУ СО «УрНИИДВиИ»
      </h1>
      {/* <div> */}
      <div className="patents__description">
        <p>
          На данной странице представлены патенты, разрешения, сертификаты и
          регистрационные удостоверения ГБУ СО «УрНИИДВиИ», подтверждающие
          научную, медицинскую и инновационную деятельность учреждения.
        </p>

        <p>
          Документы отражают результаты интеллектуальной деятельности
          специалистов института, внедрение современных методов диагностики,
          лечения и профилактики заболеваний кожи, инфекций, передающихся
          половым путем, а также других направлений дерматовенерологии и
          иммунопатологии.
        </p>
      </div>
      <WeekText data={data} />
      <div className="patents__description">
        <p>
          Представленные патенты подтверждают разработку и применение новых
          медицинских технологий, а сертификаты, регистрационные удостоверения и
          разрешительные документы свидетельствуют о соответствии продукции,
          методов и технологий действующим требованиям законодательства
          Российской Федерации.
        </p>

        <p>
          ГБУ СО «УрНИИДВиИ» уделяет особое внимание развитию научных
          исследований, внедрению инновационных решений в практическое
          здравоохранение и обеспечению высокого качества медицинской помощи.
          Публикация официальных документов позволяет ознакомиться с
          достижениями института и подтверждает высокий уровень научной и
          клинической деятельности учреждения.
        </p>
      </div>
      {/* </div> */}
    </section>
  );
}
